export const getLoadingText = (loadingText, defaultText) => {
  return loadingText || defaultText || 'Carregando...';
};

export const getButtonState = (isLoading, isDisabled) => {
  if (isLoading) return 'loading';
  if (isDisabled) return 'disabled';
  return 'default';
};



// WEBPACK FOOTER //
// ./src/design-system/molecules/LoadingButton/utils/loadingButtonHelpers.js